export { default as logger } from './isomorphicLogger';
